<script>
  import Conexoes from "../../Classes/Conexoes";
  import Constantes from "../../Classes/Constantes";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import Treino from "./Treino.svelte";
  import { Button } from "@svelteuidev/core";
  let titulo = "";
  let treinos = [];
  let isLoading = false;
  let message = "";
  let conexao = new Conexoes();
  function adicionarTreino() {
    treinos = [
      ...treinos,
      {
        id: treinos.length,
        treino: { tipo: "For Time", numero: "", tempo: "", movimentos: [] },
      },
    ];
  }

  function removerTreino() {
    treinos = treinos.slice(0, -1);
  }

  async function salvar() {
    isLoading = true;
    const dados = {
      titulo,
      treinos,
    };
    const json = JSON.stringify(dados);
    const parametros = { json: json };
    const api = "teste.php";
    let resultado = await conexao.conecta(api, parametros);
    if (resultado.sucesso) {
      message = Constantes.msg_inserido_sucesso;
    } else {
      message = Constantes.msg_erro_conexao_bd;
    }
    isLoading = false;
    // Você pode enviar esse JSON para um servidor ou salvá-lo em algum lugar conforme sua necessidade
  }
</script>

<LoadingTela {isLoading} />
<CaixaDeDialogo {message} on:close={() => (message = "")} />
<div class="margem">
  <div class="container">
    <div>
      Nome do WOD: <input type="text" id="titulo" bind:value={titulo} />
    </div>

    <div class="button-container">
      <button class="button-verde" on:click={adicionarTreino}
        >Adicionar Treino</button
      >
      <button
        class="button-vermelho"
        on:click={removerTreino}
        disabled={treinos.length === 0}>Remover Treino</button
      >
    </div>
  </div>
  <div>
    {#each treinos as treino, index (treino.id)}
      <div class="card-treino">
        <Treino id={treino.id} bind:treino={treinos[index].treino} />
      </div>
    {/each}
    {#if treinos.length > 0}
      
      <div class="centralizar card-treino">
        <Button fullSize on:click={salvar} disabled={treinos.length === 0}
          >Salvar</Button
        >
        
      </div>
    {/if}
  </div>
</div>

<style>
  .container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .centralizar {
    display: flex;
    justify-content: center; /* Centraliza horizontalmente */
    margin-top: 20px;
  }

  .button-container {
    display: flex;
    gap: 10px;
  }

  @media (max-width: 600px) {
    .container {
      flex-direction: column;
    }

    .button-container {
      margin-top: 10px;
      justify-content: center;
    }
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }

  input[type="text"],
  input[type="number"],
  input[type="time"] {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

  input[type="text"]:focus,
  input[type="number"]:focus,
  input[type="time"]:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
  }

  input[type="text"]:disabled,
  input[type="number"]:disabled,
  input[type="time"]:disabled {
    background-color: #f5f5f5;
    color: #aaa;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 100%; /* Faz o botão ocupar a largura total do seu contêiner */
  }

  .button-verde {
    background-color: #03942e;
    color: white;
  }

  .button-vermelho {
    background-color: #e75f5f;
    color: white;
  }

  .button-azul {
    background-color: #5029db;
    color: white;
  }

  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  button:not(:disabled):hover {
    color: rgb(190, 184, 184);
  }

  .button-container {
    margin: 16px 16px; /* Espaçamento superior e inferior de 16px */
  }

  .button-container button {
    margin: 16px 16px; /* Espaçamento lateral entre os botões */
  }

  .margem {
    margin-top: 70px;
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 100px;
  }

  .card-treino {
    max-width: 600px; /* Defina uma largura máxima para os cards de treino */
    margin: 0 auto; /* Centraliza o card */
  }
</style>
